/*jshint esversion: 6 */

/**
 * @description initialize each class defined in /classes.
 * @requires /classes/dnneditor.class.js
 * @requires /classes/footer.class.js
 * @requires /classes/header.class.js
 * @requires /classes/helpers.class.js (static)
 * @requires /classes/menu.class.js
 * @requires /classes/notificationbanner.class.js
 * @requires /classes/phonenumber.class.js
 * @requires /classes/plugin-loader.class.js
 */

  
const debug = false;   // true: show debug messages, false: don't show debug messages

document.addEventListener('DOMContentLoaded', () => {

  if (debug) console.log('TRITON COMMERCE DEBUG LOG');
      initializeTriton();
});


function initializeTriton() {

  window.triton = {};

  window.triton.scriptLoader = new ScriptLoader([
    {
      event: 'scroll',
      selector: '[data-accordion-group]',
      src: 'https://www.tritoncommerce.com/Portals/0/scripts/clean-accordion.min.js',
      callback: () => { PluginLoader.initAccordion(); }
    },
    {
      event: 'scroll',
      selector: '.swiper',
      src: 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-element-bundle.min.js',
      callback: () => { PluginLoader.initSlider(); }
    },
    {
      event: 'scroll',
      selector: '[data-tab-group]',
      src: 'https://www.tritoncommerce.com/Portals/0/scripts/clean-tabs.min.js',
      callback: () => { PluginLoader.initTabs(); }
    },
    {
      event: 'scroll',
      selector: '[data-fslightbox]',
      src: 'https://www.tritoncommerce.com/Portals/0/scripts/fslightbox.js',
      callback: () => { PluginLoader.initLightbox(); }
    }
  ]);

  window.triton.pluginLoader = new PluginLoader(debug);
  window.triton.phoneNumber = new PhoneNumber(debug);
  window.triton.dnneditor = new DNNEditor(debug);
  window.triton.header = new Header(debug);
  window.triton.menu = new Menu(debug);
  window.triton.notificationBanner = new NotificationBanner(debug);
}

if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !this.loaded) {

        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => this.loadWufoo(user, form));
        } else {
          setTimeout(() => this.loadWufoo(user, form), 200);
        }

        this.loaded = true;
        obs.disconnect();
      }
    });
  });
  if (this.el instanceof Element) {
    observer.observe(this.el);
  } 
} else {
  setTimeout(() => this.loadWufoo(user, form), 500);
}
